// Reads org_subscriptions for the current org. Used by the hub to render
// the app picker and (in v2) by individual product apps to gate access.

import { supabase } from '../lib/supabaseClient';

export type Product = 'persona_builder' | 'persona_studio';
export type SubscriptionStatus = 'active' | 'trial' | 'expired' | 'cancelled';

export interface OrgSubscription {
  id: string;
  orgId: string;
  product: Product;
  status: SubscriptionStatus;
  trialEndsAt: string | null;
  createdAt: string;
  updatedAt: string;
}

const ACTIVE_STATUSES: SubscriptionStatus[] = ['active', 'trial'];

export async function loadOrgSubscriptions(orgId: string): Promise<OrgSubscription[]> {
  const { data, error } = await supabase
    .from('org_subscriptions')
    .select('*')
    .eq('org_id', orgId);
  if (error) throw error;
  return (data || []).map((r) => ({
    id: r.id,
    orgId: r.org_id,
    product: r.product as Product,
    status: r.status as SubscriptionStatus,
    trialEndsAt: r.trial_ends_at,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
  }));
}

export function isActive(subscription: OrgSubscription | undefined): boolean {
  return !!subscription && ACTIVE_STATUSES.includes(subscription.status);
}
